import OrganizationSecurityContainer from 'Page/OrganizationSecurity/OrganizationSecurity.container';

function TabSecurity() {
  return <OrganizationSecurityContainer />;
}

export default TabSecurity;